import React from "react";

/**
 * Context for managing the state of the dropdown.
 * 
 * @property {any} openDropdown - The current state of the dropdown (open or closed).
 * @property {function} setOpenDropdown - Function to update the state of the dropdown.
 */
export const DropdownContext = React.createContext({
    openDropdown: null,
    setOpenDropdown: () => {},
  });
  